import { useMemo } from "react";
import type {
  PendingWorkRow,
  PendingWorkDetail,
} from "../../types/pendingWork";
import { usePendingWorkDetailsBatch } from "../../hooks/usePendingWork";
import { PendingWorkTableRow } from "./PendingWorkTableRow";

interface Props {
  rows: PendingWorkRow[];
  columns: string[];
  overdueThresholdDays: number;
}
export function PendingWorkTablePage({
  rows,
  columns,
  overdueThresholdDays,
}: Props) {
  const rootIds = useMemo(() => rows.map((row) => row.id), [rows]);
  const query = usePendingWorkDetailsBatch(rootIds);
  const detailsByRoot = useMemo(() => {
    const grouped = new Map<string, PendingWorkDetail[]>();
    query.data?.forEach((detail) => {
      const details = grouped.get(detail.rootId) || [];
      details.push(detail);
      grouped.set(detail.rootId, details);
    });
    return grouped;
  }, [query.data]);
  return (
    <>
      {rows.map((row) => (
        <PendingWorkTableRow
          key={row.id}
          row={row}
          columns={columns}
          overdueThresholdDays={overdueThresholdDays}
          details={detailsByRoot.get(row.id) || []}
          detailsQuery={query}
        />
      ))}
    </>
  );
}
